module.exports = __webpack_public_path__ + "static/media/sidebar-index.47626e4e.svg";